window.BSS_ProductGridPagination = function () {
  // Mode from body class: bss-grid-mode--pages | --load_more | --infinite
  const cls = document.body.className || '';
  const match = cls.match(/bss-grid-mode--([a-z_]+)/);
  const mode = (match && match[1]) ? match[1] : 'pages';

  // Kill any previous infinite observer
  if (window._infObs) {
    window._infObs.disconnect();
    window._infObs = null;
  }

  // Find ALL paginated product grids (collection pages, search, etc.)
  const grids = document.querySelectorAll('.product_grid_pagination, .collection__grid');
  if (!grids.length) return;

  grids.forEach((grid) => {
    // Find pagination near this grid
    const root =
      grid.closest('.collection-content') ||
      grid.closest('[data-section-id]') ||
      grid.closest('section') ||
      grid.parentElement;

    if (!root) return;

    const pagination = root.querySelector('.pagination, .collection__pagination');
    if (!pagination) return;

    const loadMoreBtn = root.querySelector('[data-bss-load-more]');

    // Helper: find next link
    const findNextLink = () =>
      pagination.querySelector('a.pagination__next, a[rel="next"], .meet_infinite_next a, .next a');

    // Helper: fetch/append next page
    const appendNextPage = async () => {
      const nextLink = findNextLink();
      if (!nextLink) return false;

      const res = await fetch(nextLink.href, { credentials: 'same-origin' });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('.product_grid_pagination, .collection__grid');
      if (newGrid) {
        newGrid.querySelectorAll('.grid__item').forEach((item) => grid.appendChild(item));
      }

      const newPagination = doc.querySelector('.pagination, .collection__pagination');
      if (newPagination) {
        pagination.innerHTML = newPagination.innerHTML;
      }

      return !!findNextLink();
    };

    // ========== MODE: PAGES ==========
    if (mode === 'pages') {
      // Show pagination normally, hide load more button
      if (pagination) pagination.style.display = '';
      if (loadMoreBtn) loadMoreBtn.style.display = 'none';
      return;
    }

    // ========== MODE: LOAD MORE ==========
    if (mode === 'load_more') {
      // Keep pagination in DOM (so next link exists), but hide it visually.
      // Button drives the loading.
      if (pagination) pagination.style.display = 'none';

      if (loadMoreBtn) {
        loadMoreBtn.style.display = '';
        loadMoreBtn.disabled = !findNextLink();

        loadMoreBtn.onclick = async () => {
          loadMoreBtn.disabled = true;
          loadMoreBtn.classList.add('is-loading');

          try {
            const hasMore = await appendNextPage();
            loadMoreBtn.disabled = !hasMore;
            if (!hasMore) loadMoreBtn.style.display = 'none';
          } catch (e) {
            console.warn('Load more error:', e);
            loadMoreBtn.disabled = false;
          } finally {
            loadMoreBtn.classList.remove('is-loading');
          }
        };
      }

      return;
    }

    // ========== MODE: INFINITE ==========
    if (mode === 'infinite') {
      // Make sure pagination exists (we use its next link)
      if (!findNextLink()) return;

      // Create trigger sentinel if missing
      let trigger = root.querySelector('#InfiniteTrigger');
      if (!trigger) {
        trigger = document.createElement('div');
        trigger.id = 'InfiniteTrigger';
        trigger.style.height = '1px';
        grid.parentNode.appendChild(trigger);
      }

      // Hide load more button in infinite mode
      if (loadMoreBtn) loadMoreBtn.style.display = 'none';

      const observer = new IntersectionObserver(async (entries) => {
        if (!entries[0].isIntersecting) return;

        observer.disconnect();

        try {
          const hasMore = await appendNextPage();
          if (hasMore) observer.observe(trigger);
        } catch (e) {
          console.warn('Infinite scroll error:', e);
        }
      }, { rootMargin: '300px' });

      observer.observe(trigger);
      window._infObs = observer;
    }
  });
};

// Run on normal page load
document.addEventListener('DOMContentLoaded', function () {
  window.BSS_ProductGridPagination();
});


// Run after theme scripts re-render sections (if your theme does this)
document.addEventListener('shopify:section:load', function () {
  window.BSS_ProductGridPagination();
});

// Re-init after filters (AJAX)
document.addEventListener('ajaxProductGrid:updated', function () {
  setTimeout(() => {
    window.BSS_ProductGridPagination();
  }, 200);
});

// Fallback observer (for any theme)
const bssObserver = new MutationObserver(() => {
  setTimeout(() => {
    window.BSS_ProductGridPagination();
  }, 200);
});

bssObserver.observe(document.body, {
  childList: true,
  subtree: true
});